import React, { useState } from "react";
import PaymentsAppLayout from "../../../Components/Molecules/PaymentsAppLayout";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import TabsSelector from "../../../Components/Atoms/TabsSelector";
import ConfigureBrandingTab from "./ConfigureBrandingTab";
import PrivateComponentLoadingPage from "../../LoadingPage/PrivateComponentLoadingPage";
import ConfigureReminderFrequencyTab from "./ConfigureReminderFrequencyTab";
import ConfigurePaymentMethodsTab from "./ConfigurePaymentMethodsTab";
import ConfigureInvoicePreferenceTab from "./ConfigureInvoicePreferenceTab";

type TabType = "branding" | "reminder_frequency" | "payment" | "invoice";

const tabs: { key: TabType; displayValue: string }[] = [
  { key: "branding", displayValue: "Branding" },
  { key: "reminder_frequency", displayValue: "Reminder Frequency" },
  { key: "payment", displayValue: "Payment Methods" },
  { key: "invoice", displayValue: "Invoice Preferences" }
];

export interface SettingsPagesChildTabProps {
  currentTabWorkDone: () => void;
}

const MyConfigurationPage: React.FC = () => {
  const [currentActiveTab, setCurrentActiveTab] = useState<TabType>("branding");
  return (
    <PaymentsAppLayout documentTitle="My Configuration">
      <TabsSelector
        tabs={tabs}
        currentActiveTab={currentActiveTab}
        setCurrentActiveTab={setCurrentActiveTab}
      />
      {currentActiveTab === "branding" ? (
        <ConfigureBrandingTab
          currentTabWorkDone={() => setCurrentActiveTab("reminder_frequency")}
        />
      ) : currentActiveTab === "reminder_frequency" ? (
        <ConfigureReminderFrequencyTab currentTabWorkDone={() => setCurrentActiveTab("payment")} />
      ) : currentActiveTab === "payment" ? (
        <ConfigurePaymentMethodsTab currentTabWorkDone={() => setCurrentActiveTab("invoice")} />
      ) : (
        <ConfigureInvoicePreferenceTab />
      )}
    </PaymentsAppLayout>
  );
};

export default withAuthenticationRequired(MyConfigurationPage, {
  onRedirecting: () => <PrivateComponentLoadingPage />
});
